import { availabilityTypeNotAvailable, availabilityStatusTypeInProgress, availabilityTypeOnlyCalendarAccess } from '@vooban/tc3-core';
import moment from 'moment';

export const getMaximumNonAvailabilityDays = ({
  selectedAvailability: { availability = availabilityTypeNotAvailable, date },
  workerAvailability: { result = [] },
  user: { email = '' },
}) => {
  const { group, worker } = result.reduce((acc, group) => {
    const worker = group.workers.find((w) => w.email === email);
    return worker ? { group, worker } : acc;
  }, {});

  if (!worker || !group) return { isMaxNonAvailableDaysReached: false };

  const { maximumNonAvailabilityDays } = group;
  const totalNonAvailableDays = worker.availabilities.filter(
    (availability) => !moment(date).isSame(moment(availability.date), 'day') && availability.availability === availabilityTypeNotAvailable
  ).length;

  const isInProgress =
    worker.availabilities.find((availability) => moment(date).isSame(moment(availability.date), 'day'))?.status === availabilityStatusTypeInProgress ||
    !!maximumNonAvailabilityDays;

  if (availability === availabilityTypeNotAvailable && maximumNonAvailabilityDays && isInProgress) {
    return { isMaxNonAvailableDaysReached: totalNonAvailableDays + 1 > maximumNonAvailabilityDays, maximumNonAvailabilityDays };
  }

  return { isMaxNonAvailableDaysReached: false };
};

export const filterOutOnlyCalendarAccessWorkers = (workers) => {
  return workers.filter((worker) => worker.defaultAvailability !== availabilityTypeOnlyCalendarAccess);
};

// Decides whether the page content can replace the loading indicator.
// Worker availability and projects are only fetched for sites that allow worker availability, so once we
// know a site doesn't allow it we must stop loading and let the "unavailable" message render — otherwise the
// worker-availability pending flag never clears and the loader spins forever.
export const isLaborAvailabilityContentReady = ({
  isFetchingSites,
  isFetchingSiteConfiguration,
  isFetchingProjects,
  siteConfiguration,
  workerAvailability,
}) => {
  if (isFetchingSites || isFetchingSiteConfiguration) return false;
  if (!siteConfiguration) return false;
  if (!siteConfiguration.allowWorkerAvailability) return true;
  return !(isFetchingProjects || (workerAvailability.isPending && workerAvailability.result.length === 0));
};
